/**
 *
 * Asynchronously loads the component for UserInterventionInvitePage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
